/* =================================================================
   VALORA PDP — offer tiles + media gallery (Shopify version).
   Cart, reveal, accordion and smooth-scroll live in valora-theme.js.
   ================================================================= */
(function () {
  "use strict";
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  // assigned by the gallery module below; lets offer selection swap the lead
  // shot that heads the gallery for the offer being considered
  var gallery = null;

  // the express-wallet buttons check out whichever offer is currently selected
  var walletOffer = null;

  // one selector per [data-offers] group, so ?offer= can drive them all at once
  var offerSelectors = [];

  /* ---------- offer tiles: selection drives the buy button ---------- */
  $$("[data-offers]").forEach(function (group) {
    var tiles = $$(".offer-tile", group);
    var section = group.closest("section") || document;
    var buyBtn = $("[data-buy-btn]", section);

    function select(tile) {
      tiles.forEach(function (t) { t.toggleAttribute("data-selected", t === tile); });
      // Each lead shot is offer-specific artwork, so only the selected offer's may show.
      // Keyed on data-offer, NOT data-qty — both bundles are 3 bottles, so quantity does
      // not identify an offer (the single bottle matches no artwork, which is correct).
      if (gallery) gallery.showOffer(tile.getAttribute("data-offer"));
      walletOffer = { id: tile.getAttribute("data-variant-id"), qty: tile.getAttribute("data-qty"), offer: tile.getAttribute("data-offer") };
      if (!buyBtn) return;
      buyBtn.setAttribute("data-variant-id", tile.getAttribute("data-variant-id"));
      buyBtn.setAttribute("data-qty", tile.getAttribute("data-qty"));
      buyBtn.setAttribute("data-offer", tile.getAttribute("data-offer") || "");
      buyBtn.setAttribute("data-product", tile.getAttribute("data-product"));
      var arrow = $(".btn__arrow", buyBtn);
      buyBtn.textContent = (tile.getAttribute("data-cta") || "Add to cart") + " ";
      if (arrow) buyBtn.appendChild(arrow);
    }

    tiles.forEach(function (tile) {
      tile.setAttribute("tabindex", "0");
      tile.setAttribute("role", "radio");
      tile.addEventListener("click", function () { select(tile); });
      tile.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(tile); }
      });
    });

    offerSelectors.push(function (offer) {
      tiles.forEach(function (t) { if (t.getAttribute("data-offer") === offer) select(t); });
    });
  });

  /* ---------- gallery: swipeable track + synced thumbnails -----------
     Photos (and the video) live in a horizontally-scrolling track with
     CSS scroll-snap, so touch users can swipe between them natively.
     Thumbnails and the prev/next arrows scroll the track to a slide;
     a scroll listener keeps the active thumb (and video playback) in
     sync when the user swipes instead of clicking.
     ------------------------------------------------------------------ */
  (function () {
    var track = $("[data-gallery-track]");
    var thumbsWrap = $("[data-gallery-thumbs]");
    if (!track || !thumbsWrap) return;
    var allSlides = $$("[data-gallery-slide]", track);
    var allThumbs = $$(".gallery__thumb", thumbsWrap);
    var prevBtn = $("[data-gallery-prev]");
    var nextBtn = $("[data-gallery-next]");
    var current = 0;

    // [data-offer-media] slides come and go with the selected offer, so the
    // working lists are filtered fresh each time rather than cached up front
    function shown(el) { return !el.hasAttribute("hidden"); }
    function slides() { return allSlides.filter(shown); }
    function thumbs() { return allThumbs.filter(shown); }

    function setActive(index) {
      current = index;
      thumbs().forEach(function (t, i) { t.classList.toggle("is-active", i === index); });
      slides().forEach(function (slide, i) {
        var video = $("[data-gallery-video]", slide);
        if (!video) return;
        if (i === index) {
          var p = video.play();
          if (p && p.catch) p.catch(function () { /* user can press play */ });
        } else {
          video.pause();
        }
      });
    }

    function goTo(index) {
      var list = slides();
      index = Math.max(0, Math.min(list.length - 1, index));
      list[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    }

    // reveal only the selected offer's lead shots; hiding the leading slide
    // shifts every index, so snap back to the top of the track afterwards
    function showOffer(kind) {
      var changed = false;
      allSlides.concat(allThumbs).forEach(function (el) {
        var mine = el.getAttribute("data-offer-media");
        if (!mine) return;
        var on = mine === kind;
        if (shown(el) === on) return;
        el.toggleAttribute("hidden", !on);
        changed = true;
      });
      if (!changed) return;
      track.scrollLeft = 0;
      setActive(0);
    }
    gallery = { showOffer: showOffer };

    allThumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () { goTo(thumbs().indexOf(thumb)); });
    });
    if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); });

    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current) setActive(index);
      }, 80);
    });
  })();

  /* ---------- ?offer= preselects a tile ------------------------------
     Lets an ad, email or landing-page button link straight to one offer:
     /products/nmn?offer=b2g1. Runs after the gallery module so the lead
     shot swaps with the tile, and before the wallet block so the express
     buttons pick up the linked offer rather than the Liquid default.
     ------------------------------------------------------------------- */
  (function () {
    if (!offerSelectors.length || !window.URLSearchParams) return;
    var want = (new URLSearchParams(window.location.search).get("offer") || "").toLowerCase().trim();
    if (!want) return;
    // the numeric aliases are the old bottle counts, kept so links already out in the
    // wild still land on the offer they were written for
    var offer = {
      system: "system", longevity: "system", reset: "system", "3": "system",
      b2g1: "b2g1", bogo: "b2g1", "2": "b2g1",
      single: "single", "1": "single"
    }[want];
    if (!offer) return;
    offerSelectors.forEach(function (selectOffer) { selectOffer(offer); });
  })();

  /* ---------- express wallets: add the offer, then hand off to checkout -------
     Shopify's product-form payment_button checks out one line item and skips the
     cart, which would strip the Longevity System's two free gifts. So these go through
     valora-theme.js's own cart path — gifts and automatic discounts land — and only
     then send the buyer to checkout, where the wallet is an express option.
     Only the wallet the device can actually use is revealed.
     -------------------------------------------------------------------------- */
  (function () {
    var wrap = $("[data-wallets]");
    if (!wrap) return;

    // select() only fires on click, so seed from the tile that starts selected
    if (!walletOffer) {
      var preset = $(".offer-tile[data-selected]");
      if (preset) walletOffer = { id: preset.getAttribute("data-variant-id"), qty: preset.getAttribute("data-qty"), offer: preset.getAttribute("data-offer") };
    }

    var supportsApple = false;
    try { supportsApple = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) { /* Safari throws on insecure origins */ }
    var supportsGoogle = /Android/i.test(navigator.userAgent) || /Chrome|CriOS|Edg/i.test(navigator.userAgent);

    var btn = supportsApple ? $('[data-wallet="apple"]', wrap)
            : supportsGoogle ? $('[data-wallet="google"]', wrap)
            : null;
    if (!btn) return; // no supported wallet — leave the plain add-to-cart button alone
    btn.hidden = false;
    wrap.hidden = false;

    btn.addEventListener("click", function () {
      var api = window.VALORA && window.VALORA.cart;
      if (!api || !walletOffer || !walletOffer.id || walletOffer.id === "0") return;
      btn.disabled = true;
      api.addOffer(walletOffer.id, walletOffer.qty, walletOffer.offer).then(function () {
        window.location.href = "/checkout";
      }).catch(function () { btn.disabled = false; });
    });
  })();
})();
